import {useContext, useEffect} from "react";
import {CostHelperContext} from "./CostHelperContext";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {PriceRow} from "../../quote/pricing/Common";
import {QuotePriceLine} from "../../../../api/QuotePricing";

export function CostFocuser(props: {
    anchorEl: any;
    row: PriceRow;
}) {
    const {show} = useContext(CostHelperContext);
    const edit = useContext(EditContext)
    const editRef = useSyncedRef(edit);

    useEffect(() => {
        if(props.row.kind !== "quote-price") return;
        const valueOriginal = props.row.value;

        return show(props.row.value, (value) => {
            const update: Partial<QuotePriceLine> = {
                unitCostCents: value.avgUnitCostCents,
                updatedAt: new Date().toISOString(),
            }

            if(value.avgMarkupPercent) {
                update.markupPercent = value.avgMarkupPercent;
            }

            editRef.current.update(Object.assign({}, props.row, {
                value: Object.assign({}, valueOriginal, update)
            }));

            editRef.current.onSelect.emit(null);
        });
    }, [show, props.row, editRef])

    return null;
}